/**
 * @file MeetingBlockHeading.tsx
 * @brief A heading on the meeting review (Overview, Summary, Agenda…).
 *
 * @details
 * ⏳ TRIAL (DES 08-10-2026, phone parity): every heading on the meeting
 * review takes the drawer's section heading (`GridHeading`: pill, dot, line)
 * instead of the plain grey subheading. `MEETING_GRID_HEADINGS` is the one
 * switch; false puts the old headings back everywhere, page titles included
 * (MeetingDetailView's title row).
 * Always held left-to-right, the pill on the left, even in right-to-left
 * content: only the AI text reads RTL (DES 08-10-2026, "heading aur notes
 * agendas ko rtl ki zaroorat nahin hai").
 *
 * Phone source: FRONTEND/src/screens/MeetingIntelligence/MeetingDetails/
 * components/MeetingBlockHeading.tsx.
 *
 * @author DES
 * @date 08-10-2026
 */

import type { ReactNode } from "react";
import { GridHeading } from "@/components/ui/GridHeading";
import { cn } from "@/shared/theme/cn";

/** The trial switch. false = the plain grey subheading everywhere. */
export const MEETING_GRID_HEADINGS = true;

/** The old heading's look (the phone layout's PhoneSubheading). */
export const MEETING_OLD_HEADING_CLS = "text-lg font-semibold tracking-[-0.5px] text-app-text/60";

export function MeetingBlockHeading({
  children,
  action,
  className,
}: {
  children: string;
  /** A control at the line's far end (drawer heading only). */
  action?: ReactNode;
  className?: string;
}) {
  if (MEETING_GRID_HEADINGS) {
    // Room under the heading before the content: the phone's 12pt gap.
    return <GridHeading label={children} action={action} dir="ltr" className={cn("mb-3", className)} />;
  }
  return <h3 className={cn("mb-2", MEETING_OLD_HEADING_CLS, className)}>{children}</h3>;
}

export default MeetingBlockHeading;
